// extracted by mini-css-extract-plugin
module.exports = {"accordionHeaderTitle":"DiscountPage_accordionHeaderTitle__3z9sp"};